import INITIAL_FILTERS from '@/retention/retention-filters/initial-filters.js';
import moment from '@utils/moment-wrapper';

export function getMoment (date, cohortSize) {
    const momentObj = moment(date, { ignoreTimeZone: true });
    if (cohortSize) momentObj.endOf(cohortSize);

    return momentObj;
}

export function getPeriodStart (cohortSize, periodCount) {
    return getMoment()
        .subtract(periodCount, cohortSize)
        .startOf(cohortSize);
}

export function getPeriodEnd (cohortSize, subtrahend = 1) {
    return getMoment()
        .subtract(subtrahend, cohortSize)
        .endOf(cohortSize);
}

export function getPeriodFilterFormat (cohortSize) {
    if (cohortSize === 'month') return 'YYYY-MM';

    return 'YYYY-MM-DD';
}

export function padCustomWeeklyPeriod (period) {
    return period.clone().add(6, 'days');
}

export function getDefaultPeriodFilters (firstEventTime, cohortSize = INITIAL_FILTERS.cohortSize) {
    let { periodStart, periodEnd, periodCount } = INITIAL_FILTERS;
    if (cohortSize === 'day') periodCount = 7;
    let defaultPeriodStart;
    const firstEventPeriodStart = moment(firstEventTime, { ignoreTimeZone: true }).startOf(cohortSize);
    defaultPeriodStart = getPeriodStart(cohortSize, periodCount);

    if (firstEventPeriodStart.isAfter(defaultPeriodStart)) {
        defaultPeriodStart = firstEventPeriodStart;
        periodCount = 'custom';
    }

    periodStart = defaultPeriodStart.format(getPeriodFilterFormat(cohortSize));
    periodEnd = getPeriodEnd(cohortSize).format(getPeriodFilterFormat(cohortSize));

    return { periodStart, periodEnd, periodCount };
}
